import { useEffect } from "react";

// The /travel page is a self-contained static site living in public/travel/
// (a mirror of the Soar landing page). React Router owns "/travel", so we
// bounce to the real static entry point. In production (Firebase Hosting) the
// static file is served directly and this component never renders; under
// `npm start` the dev server's history fallback lands here first, so we
// forward to /travel/index.html (which has an extension and is served as a
// static file, bypassing the SPA fallback).
export default function TravelRedirect() {
  useEffect(() => {
    window.location.replace("/travel/index.html");
  }, []);
  return null;
}
